import { useQuery } from 'react-query';
import { TaskCenterTypes } from '../';
import { DEFAULT_TASK_LIMIT, TaskCenterService, TASK_BY_ID_QUERY_KEY } from '../constants';
import { Filter, TaskSource } from '../types_deprecated';

const getTasksApi = TaskCenterService.ListTasks;

/**
 * TODO: Decide whether to use infinite query or not for this.
 */
export const useGetTaskBySourceId = ({
  sourceId,
  source,
  locationIds,
}: {
  sourceId: string | undefined;
  source: TaskSource;
  locationIds: string[];
}) => {
  const filter: Record<number, Filter> = {
    [TaskCenterTypes.FilterType_index.FILTER_BY_SOURCE]: {
      source,
      locationId: locationIds,
    },
    [TaskCenterTypes.FilterType_index.FILTER_BY_SOURCE_ID]: {
      locationId: locationIds,
      sourceId: sourceId ? [sourceId] : [],
    },
    [TaskCenterTypes.FilterType_index.FILTER_BY_LOCATION]: { locationId: locationIds },
  };

  return useQuery({
    queryKey: [TASK_BY_ID_QUERY_KEY],
    queryFn: async () =>
      await getTasksApi({
        filter,
        limit: DEFAULT_TASK_LIMIT,
        includeMetadata: true,
      }),
    enabled: !!source && !!sourceId,
  });
};
